export class SubscriptionSku {
    static readonly BUSINESS: string = 'business';
}